/* @generated */

// src/assets/ui-icon/external-logo/safari.tsx
import * as React from "react";
var SafariExternalLogo = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m12.276 12.983-3.49 2.327 2.243-3.574 1.247 1.247Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-15.375a.25.25 0 0 1 .25.25v1.25a.25.25 0 1 1-.5 0v-1.25a.25.25 0 0 1 .25-.25ZM12.25 18a.25.25 0 1 0-.5 0v1.25a.25.25 0 1 0 .5 0V18Zm-7.688-5.938a.25.25 0 0 1 .25-.25h1.25a.25.25 0 1 1 0 .5h-1.25a.25.25 0 0 1-.25-.25Zm13.375-.25a.25.25 0 1 0 0 .5h1.25a.25.25 0 1 0 0-.5h-1.25Zm-.678 5.51a.25.25 0 0 1-.353 0l-.884-.884a.25.25 0 1 1 .353-.354l.884.884a.25.25 0 0 1 0 .354ZM7.625 8.04a.25.25 0 0 0 .353-.354l-.884-.884a.25.25 0 0 0-.353.354l.884.884Zm3.314 2.898 5.94-3.96-3.818 6.082-5.94 3.96 3.818-6.082Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  SafariExternalLogo
};
